<template>
  <div class="page">
    <Header :notHome="true"></Header>
    <!-- pc屏幕 -->
    <div class="d-sm-none d-xl-block">
      <!-- 轮播图 -->
      <div class="swiper-area">
        <el-carousel :interval="5000" arrow="never">
          <el-carousel-item v-for="(item, index) in banner" :key="index">
            <div class="swiper-item flex align-center justify-center" @click="bannerClick(item)">
              <img :src="$BaseUrl+item.image" />
              <div class="banner-info flex flex-column">
                <span class="banner-title" :style="`color:${item.titleColour}`">{{ item.title }}</span>
                <span class="banner-subTitle"  :style="`color:${item.subTitleColour}`">{{ item.subTitle }}</span>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <!-- 新闻中心 -->
      <div class="news-area-xl">
      <div class="news-area">
        <div class="news-area-top flex align-center">
          <div class="news-area-top-left flex align-center justify-around">
            <img src="../../assets/image/icon5.png" @click="nextNewIdx(0)">
            <img src="../../assets/image/icon6.png" @click="nextNewIdx(1)">
          </div>
          <div class="news-area-top-right" @click="goDetail(newsobject.allList[newIdx],'news',0,1)">
            {{ newsobject.allList[newIdx].title }}
          </div>
        </div>
        <!--  -->
        <div class="news-area-nav flex align-center justify-between">
          <div class="news-area-nav-left flex flex-column">
            <span>新闻中心</span>
            <span>NEWS CENTER</span>
          </div>
          <div class="news-area-nav-middle flex align-center">
            <div class="new-item" v-for="(item, index) in newsNavList" :key="index" :class="{ 'active-item': currentNewsNav == index }" @click="changeCurrentNewsNav(item,index)">
              {{ item.title }}
            </div>
          </div>
          <div class="news-area-nav-right flex align-center" @click="goPage(0,currentNewsNav,((newsobject[currentNewsNav]||[{}])[0]))">
            查看更多
            <img src="../../assets/image/icon7.png" />
          </div>
        </div>
        <!-- 新闻列表 -->
        <div class="news-box flex justify-between">
          <div class="news-list flex flex-column">
            <div class="news-item flex flex-column justify-between" v-for="(item, index) in (newsobject[currentNewsNav]||[])" :key="index" @click="goDetail(item,'news',0,1)">
              <div class="news-item-title">
                {{ item.title }}
              </div>
              <div class="news-item-info flex align-center justify-between">
                <span>{{ item.type }}</span>
                <span>{{ (item.publishDate||'').substring(0,10) }}</span>
              </div>
            </div>
          </div>
          <div class="news-list-right">
            <el-carousel :interval="5000" arrow="never"  v-if="(newsobject[`all-${currentNewsNav}`])" indicator-position="none" ref="newsRightSwiper" @change="getSwiperChange($event,'newsRightSwiper')">
          <el-carousel-item v-for="(item, index) in newsobject[`all-${currentNewsNav}`]" :key="index">
            <div class="news-img flex align-center justify-center" @click="goDetail(item,'news',0,1)">
            <img :src="$BaseUrl+item.image" />
            <div class="news-img-swiper-line flex justify-between">
              <div class="news-img-swiper-icon flex align-center justify-center"  @click.stop="swiperChange(0,'newsRightSwiper')">
                <img src="../../assets/image/icon17.png"/>
              </div>
              <div class="news-img-indicator flex align-center">
                <div class="news-ind" v-for="(item,index) in newsobject[`all-${currentNewsNav}`]" :key="index" :class="{'active-ind' : infoSwiper.newsIdx == index}" ></div>
              </div>
              <div class="news-img-swiper-icon  flex align-center justify-center" @click.stop="swiperChange(1,'newsRightSwiper')">
                <img src="../../assets/image/icon18.png"/>
              </div>
            </div>
            <div class="news-info">
              <div class="news-img-title overHidden2">
                {{ item.title }}
              </div>
              <div class="news-img-info flex justify-between align-center">
                <span>{{ item.type }}</span>
                <span>{{ (item.publishDate||'').substring(0,10) }}</span>
              </div>
            </div>
          </div>
          </el-carousel-item>
        </el-carousel>
          </div>
        </div>
      </div>
    </div>
      <!-- 中心概况 -->
      <div class="centerIntr-area">
        <div class="area-title-line flex align-center justify-between">
          <div class="area-title-left flex flex-column">
            <span>中心概况</span>
            <span>CENTER PROFILE</span>
          </div>
          <div class="area-title-right" @click="goPage(1)">
            查看更多
            <img src="../../assets/image/icon7.png" />
          </div>
        </div>
        <div class="centerIntr-box">
          <div>
            <div class="centerIntr-img flex align-center justify-center">
              <img :src="$BaseUrl+aboutInfo[centerIntrIdx].coreImage">
            </div>
            <div class="centerIntr-info">
              <div class="bg-text">
                {{ aboutInfo[centerIntrIdx].bgTitle }}
              </div>
              <div class="centerIntr-info-content">
                <div class="centerIntr-info-content-title">{{ aboutInfo[centerIntrIdx].title }}</div>
                <div class="centerIntr-info-content-textarea overHidden4">
                  {{ aboutInfo[centerIntrIdx].coreContent }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="centerIntr-btn flex justify-between">
          <div v-for="(item, index) in centerIntrBtnList" :key="index" class="centerIntr-btn-item" :class="{'active-centerIntr-btn-item': centerIntrIdx == index}" @click="goCenterIntr(item.id)">
            {{ item.title }}
          </div>
        </div>
      </div>
      <!-- 组织建设 -->
      <div class="organizationa-area-xl">
      <div class="organizationa-area">
        <div class="area-title-line flex align-center justify-between">
          <div class="area-title-left flex flex-column">
            <span>组织建设</span>
            <span>ORGANIZATION CONSTRUCTION</span>
          </div>
          <div class="area-title-right" @click="goPage(2)">
            查看更多
            <img src="../../assets/image/icon8.png" />
          </div>
        </div>
        <div class="organizationa-box flex justify-between">
          <div class="organizationa-box-left">
            <el-carousel :interval="5000" arrow="never"  v-if="orgaList[0]" indicator-position="none" ref="orga0Swiper" @change="getSwiperChange($event,'orga0Swiper')">
                <el-carousel-item v-for="(item, index) in orgaList[0]" :key="index">
                  <div class="organizationa-box-left-item flex flex-column justify-between" @click.stop="goDetail(item,'orga')">
            <div class="box-item-title flex justify-between align-center">
              <span>{{item.type||'组织建设'}}</span>
              <div @click="goPage(2,(item.scrollIndex||0),item)">
                查看更多
                <img src="../../assets/image/icon7.png" />
              </div>
            </div>
            <div class="orga-img">
              <img :src="$BaseUrl+item.image" />
            </div>
            <div class="box-item-info">
              <div class="overHidden2">{{item.title}}</div>
              <!-- <div class="overHidden2">{{item.content}}</div> -->
            </div>
            <div class="organizationaL-swiper-line flex justify-between">
              <div class="organizationaL-swiper-icon flex align-center justify-center"  @click.stop="swiperChange(0,'orga0Swiper')">
                <img src="../../assets/image/icon17.png"/>
              </div>
              <div class="organizationaL-indicator flex align-center">
                <div class="organizationaL-ind" v-for="(item,index) in orgaList[0]" :key="index" :class="{'active-ind' : infoSwiper.orga0Idx == index}" ></div>
              </div>
              <div class="organizationaL-swiper-icon  flex align-center justify-center" @click.stop="swiperChange(1,'orga0Swiper')">
                <img src="../../assets/image/icon18.png"/>
              </div>
            </div>
          </div>         
                </el-carousel-item>
              </el-carousel>
          </div>
          <div class="organizationa-box-right flex flex-column justify-between">
            <div v-for="(item, index) in orgaList.slice(1,3)" :key="index" class="box-item flex align-center" @click.stop="goDetail(item[infoSwiper[`orga${index+1}Idx`]],'orga')">
              <div class="box-img-swpier">
                <el-carousel :interval="5000" arrow="never" indicator-position="none" :ref="`orga${index+1}Swiper`" @change="getSwiperChange($event,`orga${index+1}Swiper`)">
                <el-carousel-item v-for="(citem, cindex) in item" :key="cindex">
                  <div class="box-img">
                  <div class="box-item-title flex justify-between align-center">
                  <span>{{citem.type}}</span>
                  <div @click="goPage(2,citem.scrollIndex,citem)">
                    查看更多
                    <img src="../../assets/image/icon7.png" />
                  </div>
                </div>
                <div class="orga-img">
                  <img :src="$BaseUrl+citem.image" />
                </div>
                <div class="box-ind-line flex align-center justify-between">
                  <div class="box-ind-line-icon flex align-center justify-center" @click.stop="swiperChange(0,`orga${index+1}Swiper`)">
                    <img src="../../assets/image/icon25.png"/>
                  </div>
                  <div class="box-ind-area flex align-center">
                    <div v-for="(indItem,indIndex) in item" :key="indIndex" class="indItem" :class="{'active-ind' : indIndex == infoSwiper[`orga${index+1}Idx`]}"></div>
                  </div>
                  <div class="box-ind-line-icon flex align-center justify-center" @click.stop="swiperChange(1,`orga${index+1}Swiper`)">
                    <img src="../../assets/image/icon26.png"/>
                  </div>
                </div>
              </div>
                </el-carousel-item>
              </el-carousel>
              </div>
              <div class="box-info">
                <div class="overHidden">{{item[infoSwiper[`orga${index+1}Idx`]].title}}</div>
                <div class="overHidden2">{{item[infoSwiper[`orga${index+1}Idx`]].content}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
      <!-- 业务领域 -->
      <div class="service-area">
        <div class="area-title-line flex align-center justify-between">
          <div class="area-title-left flex flex-column">
            <span>业务领域</span>
            <span>BUSINESS DOMAIN</span>
          </div>
          <div class="area-title-right" @click="goPage(3)">
            查看更多
            <img src="../../assets/image/icon7.png" />
          </div>
        </div>
        <div class="service-item" v-for="(item, index) in serviceList" :key="index">
          <div class="service-item-title flex align-center justify-between">
            <span>{{item.name }}</span>
            <div @click="goPage(3,item.list[0].scrollIndex,item.list[0])" class="flex align-center">
              查看更多
              <img src="../../assets/image/icon7.png" />
            </div>
          </div>
          <div class="service-item-scroll" @click="scrollclick($event)">
            <vue-seamless-scroll :data="item.list" :class-option="defineScroll" :key="scrollViewKey">
              <div class="flex align-center service-item-scroll-list">
                <div class="service-item-scroll-item flex align-end" v-for="(cItem, index) in item.list" :key="index+99" :data="JSON.stringify(cItem)">
                  <div class="item-img flex align-center justify-center">
                    <img :src="$BaseUrl+cItem.image" />
                  </div>
                  <div>
                    <div class="overHidden2">{{ cItem.title }}</div>
                  </div>
                </div>
              </div>
            </vue-seamless-scroll>
          </div>
        </div>
      </div>
    </div>
    <!-- h5 -->
    <div class="d-xl-none d-sm-block sm-index">
      <!-- 轮播图 -->
      <div class="swiper-area">
        <el-carousel :interval="5000" arrow="never" autoplay indicator-position="none" ref="topSwiper" @change="getSwiperChange($event,'swiperIdx')">
          <el-carousel-item v-for="(item, index) in h5Banner" :key="index">
            <div class="swiper-box flex align-center justify-center" @click.stop="bannerClick(item)">
              <img :src="$BaseUrl+item.image" />
              <div class="banner-info flex flex-column">
                <span class="banner-title" :style="`color:${item.titleColour}`">{{item.title}}</span>
                <span class="banner-subTitle" :style="`color:${item.subTitleColour}`">{{item.subTitle}}</span>
              </div>
              <div class="swiper-btn-line flex align-center" v-if="h5Banner.length>1">
                <div class="left-icon>" @click.stop="swiperChange(0,'topSwiper')">
                  <img src="../../assets/image/icon17.png" />
                </div>
                <div class="swiper-btn-middle flex align-center">
                  <div v-for="(item,index) in h5Banner" :key="index" :class="{'swiper-active-item': index==swiperIdx}"></div>
                </div>
                <div class="right-icon>" @click.stop="swiperChange(1,'topSwiper')">
                  <img src="../../assets/image/icon18.png" />
                </div>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <!-- 新闻中心 -->
      <div class="news-area">
        <div class="area-title-line flex align-center justify-between">
          <div class="area-title-left flex align-baseline">
            <span>新闻中心</span>
            <span>NEWS CENTER</span>
          </div>
          <div class="area-title-right" @click="goPage(0)">
            更多
            <img src="../../assets/image/icon8.png" />
          </div>
        </div>
        <div class="news-type-line flex align-center">
          <div class="news-type-item" :class="{'news-type-active-item': index==currentNewsNav}" v-for="(item,index) in newsNavList" :key="index" @click="changeCurrentNewsNav(item,index)">
            {{ item.title }}
          </div>
        </div>
        <div class="swiper-box">
          <el-carousel :interval="1000000" arrow="never" :autoplay="false" indicator-position="none" ref="newsSwiper">
            <el-carousel-item v-for="(item, index) in newsobject[currentNewsNav]" :key="index">
              <div class="img-area flex align-center justify-center" @click="goDetail(item,'news',0,1)">
                <img :src="$BaseUrl+item.image" />
                <div @click.stop="swiperChange(0,'newsSwiper')" class="left-icon">
                  <img src="../../assets/image/icon17.png" />
                </div>
                <div @click.stop="swiperChange(1,'newsSwiper')" class="right-icon">
                  <img src="../../assets/image/icon18.png" />
                </div>
                <div class="img-info overHidden2">
                  <div class="overHidden2">
                    {{item.title}}
                  </div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
          <!-- :class="{'active-news-item': index==0}" -->
          <div class="news-item flex" v-for="(item,index) in newsobject[currentNewsNav]" :key="index" @click="goDetail(item,'news',true,1)">
            <div class="news-item-left flex flex-column justify-center">
              <span>{{item.showTime[0]}}</span>
              <span>{{item.showTime[1]}}</span>
            </div>
            <div class="overHidden2 news-item-right flex align-center">
              <div class="overHidden2">{{item.title}}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 中心概况 -->
      <div class="centerIntr-area">
        <div class="area-title-line flex align-center justify-between">
          <div class="area-title-left flex align-baseline">
            <span>中心概况</span>
            <span>CENTER PROFILE</span>
          </div>
          <div class="area-title-right" @click="goPage(1)">
            查看更多
            <img src="../../assets/image/icon7.png" />
          </div>
        </div>
        <div class="centerIntr-box">
          <div class="swiper-box">
            <el-carousel :interval="1000000" arrow="never" :autoplay="false" indicator-position="none" ref="centerIntrSwiper">
              <el-carousel-item v-for="(item, index) in h5centerIntroList" :key="index">
                <div class="img-area">
                  <img :src="$BaseUrl+item.coreImage" />
                  <div class="img-info flex flex-column">
                    <div class="img-info-top flex align-end">
                      <div @click="swiperChange(0,'centerIntrSwiper')">
                        <img src="../../assets/image/icon17.png" />
                      </div>
                      <div class="img-info-top-title">
                        {{item.bgTitle}}
                      </div>
                      <div @click="swiperChange(1,'centerIntrSwiper')">
                        <img src="../../assets/image/icon18.png" />
                      </div>
                    </div>
                    <div class="img-line flex align-center">
                      <!-- centerIntrBtnList -->
                         <div v-for="(item,index) in h5centerIntroList" :key="index" :class="{'active-line': centerIntrIdxH5==index}"></div>
                      </div>
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
          <!-- <div class="img-line flex align-center">
            <div v-for="(item,index) in 1" :key="index" :class="{'active-line': centerIntrIdxH5==index}"></div>
          </div> -->
          <div class="centerIntr-content">
            <div class="overHidden4" v-if="h5centerIntroList[centerIntrIdxH5]">
              {{h5centerIntroList[centerIntrIdxH5].coreContent}}
            </div>
          </div>
        </div>
      </div>
      <!-- 组织建设 -->
      <div class="organizationa-area">
        <div class="area-title-line flex align-center justify-between">
          <div class="area-title-left flex align-baseline">
            <span>组织建设</span>
            <span>ORGANIZATION CONSTRUCTION</span>
          </div>
          <div class="area-title-right flex align-center" @click="goPage(2)">
            更多
            <img src="../../assets/image/icon8.png" />
          </div>
        </div>
        <div class="sm-organizationa-box flex justify-between">
          <div class="sm-organizationa-showBox flex">
            <div class="sm-organizationa-box-left">
              <div v-for="(item,index) in orgaTitleList" :key="index" class="overHidden" :class="{'active-organization': index==organizationActiveIdx}" @click="changeOrgaTitleIdx(item)">
                {{item.title}}
              </div>
            </div>
            <div class="sm-organizationa-box-right flex flex-column justify-between" @click="goDetail((orgaObject[organizationActiveIdx]?orgaObject[organizationActiveIdx][0]:null),'orga')">
              <div>
                <div class="sm-organizationa-box-img flex align-center justify-center">
                  <img :src="$BaseUrl+(orgaObject[organizationActiveIdx]?orgaObject[organizationActiveIdx][0].image:'01.png')" />
                </div>
                <div class="sm-organizationa-box-title overHidden2">
                  {{orgaObject[organizationActiveIdx]?orgaObject[organizationActiveIdx][0].title:''}}
                </div>
              </div>
              <div class="sm-organizationa-box-more" @click="(orgaObject[organizationActiveIdx]&&orgaObject[organizationActiveIdx][0])?goPage(2,orgaObject[organizationActiveIdx][0].scrollIndex,orgaObject[organizationActiveIdx][0]):goPage(2)">
                <span>更多</span>
                <img src="../../assets/image/icon8.png">
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 业务领域 -->
      <div class="service-area">
        <div class="area-title-line flex align-center justify-between">
          <div class="area-title-left flex align-baseline">
            <span>业务领域</span>
            <span>BUSINESS DOMAIN</span>
          </div>
          <div class="area-title-right" @click="goPage(3)">
            更多
            <img src="../../assets/image/icon7.png" />
          </div>
        </div>
        <div class="service-item" v-for="(item, index) in serviceList" :key="index">
          <div class="service-item-title flex align-center justify-between">
            <span>{{ item.name }}</span>
          </div>
          <div class="sm-service-item-scroll" @click="scrollclick($event)">
            <vue-seamless-scroll :data="item.list" :class-option="defineScroll" :key="scrollViewKey">
              <div class="flex align-center service-item-scroll-list">
                <div class="service-item-scroll-item" v-for="(citem, cindex) in item.list" :key="cindex+99" :data="JSON.stringify(citem)">
                  <div class="service-item-img flex align-center justify-center">
                    <img :src="$BaseUrl+citem.image" />
                  </div>
                  <div class="service-item-desc">
                    <div class="overHidden">{{ citem.title }}</div>
                  </div>
                </div>
              </div>
            </vue-seamless-scroll>
          </div>
          <div>
            <div class="sm-service-item-more flex align-center" @click="goPage(3,item.list[0].scrollIndex,item.list[0])">
              <span>更多</span>
              <img src="../../assets/image/icon8.png" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="d-xl-block d-sm-none">
      大屏显示
    </div>
    <div class="d-sm-block d-xl-none">
      小屏显示
    </div> -->
    <Footer></Footer>
  </div>
</template>
<script>
import vueSeamlessScroll from "vue-seamless-scroll";
import { getBanner, getNews, getCore, getOrganization, getBusiness } from "@/api/index"
export default {
  components: {
    vueSeamlessScroll
  },
  data() {
    return {
      banner: [],
      h5Banner:[],
      currentNewsNav: 0,
      newsNavList: [
      //   {
      //   title: '中心公告',
      //   id: 0
      // },
      {
        title: '通知公告',
        id: 3
      },
       {
        title: '最新新闻',
        id: 1
      }, {
        title: '行业动态',
        id: 2
      }],
      newsList: [],
      centerIntrBtnList: [{
        title: '中心简介',
        id: 0
      }, {
        title: '领导介绍',
        id: 1
      }, {
        title: '产业布局',
        id: 2
      }, {
        title: '业务范围',
        id: 3
      }, {
        title: '发展规划',
        id: 4
      }, {
        title: '荣誉与成就',
        id: 5
      }, {
        title: '社会责任',
        id: 6
      }],
      orgaTitleList: [{
        title: '党群动态',
        id: 0
      }, {
        title: '党建活动',
        id: 1
      }, {
        title: '培训学习',
        id: 2
      }],
      defineScroll: {
        step: 0.4, // 数值越大速度滚动越快
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 2, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动)direction => 0/1                                
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
      },
      serviceList: [],
      organizationActiveIdx: 0,
      centerIntrIdx: 0,
      swiperIdx: 0,
      newsobject: {
        0: [],
        allList: [{}],
        'all-0':[]
      },
      newIdx: 0,
      aboutInfo: {
        0:{}
      },
      orgaList: [],
      orgaObject: { 0: [{}] },
      centerIntrIdx:0,
      infoSwiper:{
        newsIdx:0,
        orga0Idx:0,
        orga1Idx:0,
        orga2Idx:0
      },
      scrollViewKey:-1,
      h5centerIntroList:[],
      centerIntrIdxH5:0
    }
  },
  mounted() {
    this.countViewCount()
    this.getHomeData()
    window.addEventListener('resize', this.resizeRefreshScorllView);
    // this.countViewCount()
  },
  destroyed(){
    window.removeEventListener('resize', this.resizeRefreshScorllView);
  },
  methods: {
    getHomeData() {
      getBanner().then(res => {
        if (res.code == 200) {
          // this.banner = res.rows
          if(res.rows.length!=0){
             let result=res.rows.reduce((result,curV)=>{
              if(curV.showType==1){
                result.h5.push({...curV})
              }else if(curV.showType==2){
                result.pc.push({...curV})
              }
              return result
             },{h5:[],pc:[]})
             this.banner=result.pc
             this.h5Banner=result.h5
          }
        }
      })
      getNews().then(res => {
        if (res.code == 200) {
          let tempObject = {
            '最新新闻': 1,
            '行业动态': 2,
            '通知公告': 0
          }
          this.newsobject = {
            allList: []
          }
          res.data.forEach(t => {
            let tempList = t.list.map(v => {
              v.scrollIndex = '通知公告'?tempObject[t.name]:0
              v.type = t.name
              let d = (v.publishDate||'').substring(0, 10).split('-')
              v.showTime = [d[0], `${d[1]}-${d[2]}`]
              v.desc = (v.content || '').replace(/<img.*?>/g, "").replace(/<\/?.+?\/?>/g, ' ')
              return v
            })
            this.newsobject.allList = this.newsobject.allList.concat(tempList)
            this.$set(this.newsobject, `all-${tempObject[t.name]}`, tempList.slice(0, 7))
            this.$set(this.newsobject, tempObject[t.name], tempList.slice(0, 3))
          })
        }
      })
      getCore().then(res => {
        if (res.code == 200) {
          this.h5centerIntroList=[]
          // 中心简介
          let t = (res.data.find(v => v.name == '中心简介').list || [[{}]])[0]
          let temp = t[0] || {}
          temp.coreContent = (temp.coreContent || '').replace(/<img.*?>/g, "").replace(/<\/?.+?\/?>/g, ' ')
          temp.bgTitle='中心简介'
          // this.aboutInfo = temp
          this.$set(this.aboutInfo,0,temp)
          this.h5centerIntroList.push(temp)
          // 中心概况
          let plan=(res.data.find(v => v.name == '中心概况').list || [[{}]])[0]
          temp=plan[0] || {}
          let obj4={
            coreImage:temp.developImage,
            coreContent:temp.developContent,
            title:'发展规划',
            bgTitle:'发展规划'
          }
          this.h5centerIntroList.push(obj4)
          let obj6={
            coreImage:temp.societyImage,
            coreContent:temp.societyContent,
            title:'社会责任',
            bgTitle:'社会责任'
          }
          this.h5centerIntroList.push(obj6)
          this.$set(this.aboutInfo,4,obj4)
          this.$set(this.aboutInfo,6,obj6)
        }
      })
      getOrganization().then(res => {
        if (res.code == 200) {
          let tempObject = {
            '党群动态': 0,
            '党建活动': 1,
            '培训学习': 2,
          }
          this.orgaList = []
          let tempList = []
          res.data.forEach(t => {
            if (t.list.length != 0) {
              let list = t.list.map(v => {
                v.type = t.name
                v.scrollIndex = tempObject[t.name]
                v.content = (v.content || '').replace(/<img.*?>/g, "").replace(/<\/?.+?\/?>/g, ' ')
                return v
              })
              this.$set(this.orgaObject, tempObject[t.name], list)
              this.orgaList.push(list.slice(0,7))
              tempList.push(list)
            }
          })
          // console.log(this.orgaObject)
          if (this.orgaList.length < 3 && tempList.length > 0) {
            this.orgaList.concat(tempList)
          }
        }
      })
      getBusiness().then(res => {
        if (res.code == 200) {
          let tempObject = {
            '产品与服务': 0,
            '技术与创新': 1,
            '行业动向': 2,
          }
          // console.log(res.data)
          let serviceList = []
          res.data.forEach(v => {
            if (v.list.length != 0) {
              v.list = v.list.map(t => {
                t.type = v.name
                t.scrollIndex = tempObject[v.name]
                return t
              })
              if(v.list.length==4||v.list.length==3){
                v.list=v.list.concat(v.list)
              }
              serviceList.push(v)
            }
          })
          this.serviceList = serviceList
          // console.log(this.serviceList)
        }
      })
    },
    nextNewIdx(index) {
      if (index == 1) {
        this.newIdx = (this.newIdx + 1) >= (this.newsobject.allList.length) ? 0 : (this.newIdx + 1)
      } else {
        this.newIdx = (this.newIdx - 1) < 0 ? (this.newsobject.allList.length - 1) : (this.newIdx - 1)
      }
    },
    changeCurrentNewsNav(item, index) {
      this.currentNewsNav = index
    },
    changeOrgaTitleIdx(item) {
      this.organizationActiveIdx = item.id
    },
    goCenterIntr(index){
      this.centerIntrIdx=index
      if(!(index==0||index==6||index==4)){
        this.goPage(1,index)
      }
    },
    goDetail(item, type,setTimeoutFlag,speFlag) {
      setTimeout(()=>{
        if (type == 'news') {
          if(speFlag){
            let temp=item.scrollIndex==0?3:item.scrollIndex
            this.$router.push({ path: '/newsDetail?contentId=' + item.contentId + '&type=' + type + '&pageName=' + item.type + '&scroll=' + temp }) 
          }else{
            this.$router.push({ path: '/newsDetail?contentId=' + item.contentId + '&type=' + type + '&pageName=' + item.type + '&scroll=' + item.scrollIndex })
          }
      } else if (type == 'orga') {
        this.$router.push({ path: '/newsDetail?contentId=' + item.contentId + '&type=' + type + '&pageName=' + item.type + '&scroll=' + item.scrollIndex })
      } else if (type == 'bussiness') {
        this.$router.push({ path: '/newsDetail?contentId=' + item.contentId + '&type=' + type + '&pageName=' + item.type + '&scroll=' + item.scrollIndex })
      }
      },(setTimeoutFlag?500:0))
      // console.log(item)
    },
    swiperChange(index, name) {
      if (index == 0) {
        if(name=='orga1Swiper'||name=='orga2Swiper'){
          this.$refs[name][0].prev()
        }else{
          this.$refs[name].prev()
        }
        if (name == 'centerIntrSwiper') {
          this.centerIntrIdxH5 = (this.centerIntrIdxH5 - 1) < 0 ? this.h5centerIntroList.length - 1 : (this.centerIntrIdxH5 - 1)
        } else if (name == 'topSwiper') {
          this.swiperIdx = (this.swiperIdx - 1) < 0 ? this.h5Banner.length - 1 : (this.swiperIdx - 1)
        }else if(name=='newsRightSwiper'){
          this.infoSwiper.newsIdx = (this.newsobject[`all-${this.currentNewsNav}`].length - 1) < 0 ? this.newsobject[`all-${this.currentNewsNav}`].length - 1 : (this.infoSwiper.newsIdx - 1)
        }else if(name=='orga0Swiper'){
          this.infoSwiper.orga0Idx = (this.orgaList[0].length - 1) < 0 ? this.orgaList[0].length - 1 : (this.infoSwiper.orga0Idx - 1)
        }else if(name=='orga1Swiper'){
          this.infoSwiper.orga1Idx = (this.orgaList[1].length - 1) < 0 ? this.orgaList[1].length - 1 : (this.infoSwiper.orga1Idx - 1)
        }else if(name=='orga2Swiper'){
          this.infoSwiper.orga2Idx = (this.orgaList[2].length - 1) < 0 ? this.orgaList[2].length - 1 : (this.infoSwiper.orga2Idx - 1)
        }
      } else {
        if(name=='orga1Swiper'||name=='orga2Swiper'){
          this.$refs[name][0].next()
        }else{
          this.$refs[name].next()
        }
        if (name == 'centerIntrSwiper') {
          this.centerIntrIdxH5 = this.centerIntrIdxH5 + 1 > (this.h5centerIntroList.length - 1) ? 0 : this.centerIntrIdxH5 + 1
        } else if (name == 'topSwiper') {
          this.swiperIdx = this.swiperIdx + 1 > (this.h5Banner.length - 1) ? 0 : this.swiperIdx + 1
        } else if (name == 'newsRightSwiper') {
          this.infoSwiper.newsIdx = this.infoSwiper.newsIdx + 1 > (this.newsobject[`all-${this.currentNewsNav}`].length - 1) ? 0 : this.infoSwiper.newsIdx + 1
        } else if (name == 'orga0Swiper') {
          this.infoSwiper.orga0Idx = this.infoSwiper.orga0Idx + 1 > (this.orgaList[0].length - 1) ? 0 : this.infoSwiper.orga0Idx + 1
        } else if (name == 'orga1Swiper') {
          this.infoSwiper.orga1Idx = this.infoSwiper.orga1Idx + 1 > (this.orgaList[1].length - 1) ? 0 : this.infoSwiper.orga1Idx + 1
        } else if (name == 'orga2Swiper') {
          this.infoSwiper.orga2Idx = this.infoSwiper.orga2Idx + 1 > (this.orgaList[2].length - 1) ? 0 : this.infoSwiper.orga2Idx + 1
        }
      }
    },
    getSwiperChange(e,name){
       if(name=='newsRightSwiper'){
        this.infoSwiper.newsIdx=e
       }else if(name=='orga0Swiper'){
        this.infoSwiper.orga0Idx=e
       }else if(name=='swiperIdx'){
        this.swiperIdx=e
       }else if(name=='orga1Swiper'){
        this.infoSwiper.orga1Idx=e
       }else if(name=='orga2Swiper'){
        this.infoSwiper.orga2Idx=e
       }
    },
    goPage(index, scroll, item) {
      if (index == 0) {
        if (item != undefined) {
          let temp=this.currentNewsNav==0?3:this.currentNewsNav
          this.$router.push({ path: '/newsList?categoryOne=' + item.categoryOne + '&categoryTwo=' + item.categoryTwo + '&type=news&scroll=' + temp })
        } else {
          this.$router.push({ path: '/news' })
        }
        // this.$router.push({path:'/news?to='+this.currentNewsNav})
      } else if (index == 1) {
        if (scroll != undefined) {
          this.$router.push({ path: '/overview?to=' + scroll })
        } else {
          this.$router.push({ path: '/overview' })
        }
      } else if (index == 2) {
        if (scroll != undefined) {
          // this.$router.push({path:'/organizational?to='+scroll})
          this.$router.push({ path: '/newsList?categoryOne=' + item.categoryOne + '&categoryTwo=' + item.categoryTwo + '&type=orga&scroll=' + scroll })
        } else {
          this.$router.push({ path: '/organizational' })
        }
      } else if (index == 3) {
        if (scroll != undefined) {
          this.$router.push({ path: '/newsList?categoryOne=' + item.categoryOne + '&categoryTwo=' + item.categoryTwo + '&type=bussiness&scroll=' + scroll })
        } else {
          this.$router.push({ path: '/bussiness' })
        }
      }
    },
    bannerClick(item) {
      if (item.url && item.url.indexOf('http') != -1) {
        window.open(item.url)
      }
    },
    scrollclick(e){
      const path = e.path || (e.composedPath && e.composedPath());
      let target = path.filter((r) => /service-item-scroll-item/.test(r.className));
      if (target.length) target = target[0];
      else return;
      const data = JSON.parse(target.getAttribute("data")); // 单项数据详情
      this.goDetail(data,'bussiness')
      // this.$emit("supervise-detail",data.name, data.type);
    },
    resizeRefreshScorllView(){
      this.scrollViewKey=Math.random()
    }
  }
}
</script>
<style scoped lang="scss">
/* 标题 */
.area-title-line {
  max-width: 1440px;
  margin: 0 auto;
  user-select: none;

  .area-title-left {
    span:first-of-type {
      font-family: "SourceHanSansCN-Regular";
      font-weight: bold;
      font-size: 36px;
      color: #ffffff;
    }

    span:last-of-type {
      font-family: "SourceHanSansCN-Regular";
      font-weight: 400;
      font-size: 10px;
      color: rgba(255, 255, 255, 0.8);
      line-height: 11px;
      letter-spacing: 2px;
      text-align: left;
      font-style: normal;
    }
  }

  .area-title-right {
    font-family: "SourceHanSansCN-Regular";
    font-weight: 400;
    font-size: 16px;
    color: #ffffff;
    cursor: pointer;
    display: flex;
    align-items: center;

    img {
      width: 50px;
      height: 14px;
      margin-left: 8px;
    }
  }
}

/* 轮播图 */
.swiper-area {
  width: 100%;
  min-height: 1000px;

  /deep/.el-carousel__container {
    // height: 800px;
    min-height: 1000px;
  }

  .swiper-item {
    position: relative;

    img {
      width: 100%;
      object-fit: cover;
      // height: 800px;
      min-height: 1000px;
    }

    .banner-info {
      width: 1440px;
      position: absolute;
      left: 50%;
      top: 464px;
      margin-left: -720px;
      padding: 0 40px;
    }

    .banner-title {
      font-family: "SourceHanSansCN-Regular";
      font-weight: bold;
      font-size: 75px;
      color: #ffffff;
    }

    .banner-subTitle {
      font-family: "SourceHanSansCN-Regular";
      font-weight: 400;
      font-size: 20px;
      color: rgba(255, 255, 255, 0.8);
    }
  }

  ::v-deep .el-carousel__indicators {
    left: unset;
    right: 56px;
    bottom: 300px;
    display: flex;
    flex-direction: column;
  }

  ::v-deep .el-carousel__indicator--horizontal {
    padding: 0;
    padding-top: 12px;
  }

  ::v-deep .el-carousel__button {
    width: 12px;
    height: 12px;
    background: #ffffff !important;
    opacity: 1;
  }

  ::v-deep .is-active .el-carousel__button {
    background: #14a5fe !important;
    opacity: 1;
  }
}

/* 新闻中心 */
.news-area-xl{
  width: 100%;
  // background: red;
  padding-bottom: 100px;
  background-image: url('../../assets/image/bg29.png');
  // background: red;
  background-size: cover;
  background-size: 1920px 680px;
  background-position: calc(50%) 0;
  // min-height: 895px;
}
.news-area {
  // background: #fff;
  max-width: 1440px;
  margin: 0 auto;
  z-index: 55;
  margin-top: -68px;
  position: relative;
  .area-title-right {
    color: #3b7af4;
  }
  .news-area-top {
    padding: 7px 0;
    box-shadow: 0px -15px 15px 0px rgba(10,49,128,0.3);
    // border-bottom: 1px solid #0a3180;
    background: #fff;

    &-left {
      width: 140px;
      height: 54px;
      border-right: 2px solid #009dff;
      flex-shrink: 0;

      img {
        width: 13px;
        height: 23px;
        cursor: pointer;
      }
    }

    &-right {
      font-family: "SourceHanSansCN-Regular";
      font-weight: 400;
      font-size: 24px;
      color: rgba(51, 51, 51, 0.5);
      user-select: none;
      padding-left: 30px;
      min-width: 0;
      flex: 1;
      cursor: pointer;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    &-right:hover{
      color: rgba(51, 51, 51, 1);
    }
  }

  .news-area-nav {
    user-select: none;
    width: 1192px;
    height: 112px;
    background: rgba(21, 102, 212, 0.8);
    margin-top: 60px;
    padding: 20px 40px;
    z-index: 20;
    position: relative;

    &-left {
      flex-shrink: 0;

      > span:first-of-type {
        font-family: "SourceHanSansCN-Regular";
        font-weight: bold;
        font-size: 36px;
        color: #ffffff;
      }

      > span:last-of-type {
        font-family: "SourceHanSansCN-Regular";
        font-weight: 400;
        font-size: 10px;
        color: rgba(255, 255, 255, 0.8);
        letter-spacing: 2px;
      }
    }

    &-middle {
      padding-left: 30px;
      flex: 1;
      min-width: 0;

      .new-item {
        font-family: "SourceHanSansCN-Regular";
        font-weight: 400;
        font-size: 16px;
        color: rgba(255, 255, 255, 0.8);
        padding: 5px 12px;
        cursor: pointer;
      }

      .new-item:hover {
        color: #fff;
      }

      .active-item {
        font-weight: 500;
        color: #ffffff;
        position: relative;
      }

      .active-item::after {
        position: absolute;
        width: 68px;
        height: 4px;
        background: #ffffff;
        left: 10px;
        bottom: 0;
        content: "";
      }
    }

    &-right {
      flex-shrink: 0;
      font-family: "SourceHanSansCN-Regular";
      font-weight: 400;
      font-size: 16px;
      color: #ffffff;

      img {
        width: 50px;
        height: 14px;
        margin-left: 8px;
      }
    }
  }

  .news-box {
    margin-top: -30px;
    // background: rgb(249, 249, 249);

    .news-list {
      // justify-content: end;
      padding-top: 43px;

      .news-item {
        width: 710px;
        height: 119px;
        padding: 20px;
        cursor: pointer;

        &-title {
          font-family: "SourceHanSansCN-Regular";
          font-weight: 400;
          font-size: 20px;
          color: #333333;
        }

        &-info {
          font-family: "SourceHanSansCN-Regular";
          font-weight: 400;
          font-size: 16px;
          color: #999999;
          line-height: 14px;
        }
      }

      .news-item:hover {
        background: #1566d4;

        .news-item-title {
          color: #fff;
        }
        .news-item-info {
          span {
            color: rgba(#fff, $alpha: 0.6);
          }
        }
      }
    }
    .news-list-right{
      width: 712px;
      /deep/.el-carousel__container{
      min-height: 402px;
      width: 712px;
    }
      .news-img {
      width: 712px;
      height: 402px;
      position: relative;
      // -webkit-box-shadow: 10px 10px 8px #888888;
      // box-shadow: 3px 3px 8px #888888;
      cursor: pointer;
      overflow: hidden;
      img {
        width: 100%;
        height: 402px;
        object-fit: cover;
      }

      .news-info {
        width: 100%;
        position: absolute;
        bottom: 0;
        padding: 15px;
        cursor: pointer;
        background: linear-gradient( 180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.8) 100%);

        .news-img-title {
          font-family: "SourceHanSansCN-Regular";
          font-weight: bold;
          font-size: 24px;
          color: #ffffff;
          line-height: 36px;
        }

        .news-img-info {
          font-weight: 400;
          font-size: 20px;
          color: #ffffff;
          line-height: 30px;
        }
      }
      .news-img-swiper-line{
      width: 100%;
      position: absolute;
      left: 0;
      top: 140px;
      .news-img-swiper-icon{
        background: rgba($color: #000000, $alpha: 1);
        width: 80px;
        height: 120px;
        cursor: pointer;
        opacity: 0.5;
        img{
          width: 17px;
          height: 31px;
        }
      }
      .news-img-indicator{
        height: 137px;
        padding-top: 130px;
        .news-ind{
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background: #fff;
          margin-right: 10px;
        }
        .active-ind{
          width: 40px;
          height: 6px;
          background: #1566D4;
        }
      }
    }
    }
     // 移入效果 
    .news-img:hover{
      .news-img-swiper-line{
        .news-img-swiper-icon{
          background: rgba($color: #000000, $alpha: 0.5);
          opacity: 1;
        }
      }
      .news-info {
        background: linear-gradient( 180deg, rgba(21,102,212,0) 0%, #1566D4 100%);
      }
    }
    }
  }
}

/*中心概况*/
.centerIntr-area {
  min-height: 822px;
  background-image: url("../../assets/image/bg2.png");
  background-size: cover;
  // max-width: 1440px;
  margin: 0 auto;
  // margin-top: 75px;
  padding-top: 75px;
  padding-bottom: 75px;

  .centerIntr-box {
    margin-top: 15px;
    text-align: center;

    > div {
      display: inline-block;
      margin: 0 auto;
    }

    .centerIntr-img {
      width: 656px;
      height: 370px;
      overflow: hidden;

      img {
        width: 656px;
        height: 370px;
        object-fit: cover;
      }
    }

    .centerIntr-info {
      position: relative;
      z-index: 10;
      width: 560px;
      height: 370px;
      background: rgba(21, 102, 212, 0.8);
      margin-top: -314px;
      margin-left: 432px;

      .bg-text {
        font-family: "SourceHanSansCN-Regular";
        font-weight: 800;
        font-size: 110px;
        // color: rgba(255,255,255,0);
        background: linear-gradient(
          to bottom,
          #b4d4ff 0%,
          rgba(21, 102, 212, 0.5) 100%
        );
        -webkit-background-clip: text;
        /*将设置的背景颜色限制在文字中*/

        -webkit-text-fill-color: transparent;
        /*给文字设置成透明*/
        user-select: none;
      }

      .centerIntr-info-content {
        margin-top: -50px;
        font-family: "SourceHanSansCN-Regular";
        padding: 0 30px 30px 30px;
        user-select: none;

        &-title {
          font-weight: bold;
          font-size: 24px;
          color: #ffffff;
          text-align: left;
          padding-bottom: 24px;
          border-bottom: 1px solid rgba(255, 255, 255, 0.8);
        }

        &-textarea {
          padding-top: 25px;
          font-weight: 400;
          font-size: 20px;
          color: #ffffff;
          text-align: left;
        }
      }
    }
  }

  .centerIntr-btn {
    max-width: 1440px;
    border-top: 3px solid rgba(255, 255, 255, 0.5);
    margin: 0 auto;
    margin-top: 30px;
    padding-top: 20px;

    &-item {
      font-family: "SourceHanSansCN-Regular";
      font-weight: 500;
      font-size: 24px;
      color: #333333;
      padding: 15px 40px;
      background: rgba(255, 255, 255, 0.8);
      user-select: none;
      cursor: pointer;
    }

    .centerIntr-btn-item:hover {
      // animation-name: centerIntrBtnHover;
      // animation-duration: 0.3s;
      // animation-iterationcount: 1;
      // padding: 15px 80px;
      background: #fff;
    }
    .active-centerIntr-btn-item{
      animation-name: centerIntrBtnHover;
      animation-duration: 0.3s;
      animation-iterationcount: 1;
      padding: 15px 80px;
      background: #1566d4!important;
      color: #fff;
    }
  }
}

@keyframes centerIntrBtnHover {
  from {
    padding: 15px 40px;
  }

  16% {
    padding: 15px 55px;
  }

  33% {
    padding: 15px 60px;
  }

  48% {
    padding: 15px 65px;
  }

  66% {
    padding: 15px 70px;
  }

  84% {
    padding: 15px 75px;
  }

  to {
    padding: 15px 80px;
  }
}

// 组织建设
.organizationa-area-xl{
  width: 100%;
  padding-bottom:75px;
  background-image: url("../../assets/image/bg30.png");
  background-size: cover;
  min-width: 678px;
}
.organizationa-area {
  max-width: 1440px;
  margin: 0px auto 0 auto;
  padding-top: 70px;
  

  .area-title-line {
    .area-title-left {
      > span:first-of-type {
        color: #333333;
      }

      > span:last-of-type {
        color: rgba(51, 51, 51, 0.8);
      }
    }

    .area-title-right {
      color: #3b7af4;
    }
  }

  .organizationa-box {
    margin: 30px auto 0 auto;
    max-width: 1440px;

    .box-item-title {
      padding: 20px;
      user-select: none;
      background: linear-gradient( 360deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.5) 100%);
      > span {
        font-family: "SourceHanSansCN-Regular";
        font-weight: bold;
        font-size: 24px;
        color: #ffffff;
        line-height: 36px;
      }

      > div {
        font-family: "SourceHanSansCN-Regular";
        font-weight: 400;
        font-size: 16px;
        color: rgba(255, 255, 255, 0.8);
        cursor: pointer;

        img {
          width: 50px;
          height: 14px;
          margin-left: 8px;
        }
      }
    }
    .organizationa-box-left {
      width: 712px;
      height: 402px;
      // background-image: url("../../assets/image/img1.png");
      background-size: cover;
      position: relative;
      /deep/.el-carousel__container{
        width: 712px;
        min-height: 402px;
    }
      .box-item-title {
        position: absolute;
        top: 0;
        width: 100%;
      }
      .orga-img {
        width: 712px;
        height: 402px;
        img {
          width: 712px;
          height: 402px;
          object-fit: cover
        }
      }
      .box-item-info {
        padding: 15px;
        position: absolute;
        bottom: 0;
        width: 100%;
        background: linear-gradient( 180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.8) 100%);
        > div:first-of-type {
          font-family: "SourceHanSansCN-Regular";
          font-weight: bold;
          font-size: 20px;
          color: #ffffff;
          margin-bottom: 15px;
        }

        // > div:last-of-type {
        //   font-family: "SourceHanSansCN-Regular";
        //   font-weight: 400;
        //   font-size: 20px;
        //   color: rgba(255, 255, 255, 0.7);
        // }

      }
      .organizationaL-swiper-line{
      width: 100%;
      position: absolute;
      left: 0;
      top: 140px;
      .organizationaL-swiper-icon{
        background: rgba($color: #000000, $alpha: 1);
        width: 80px;
        height: 120px;
        cursor: pointer;
        opacity: 0.5;
        img{
          width: 17px;
          height: 31px;
        }
      }
      .organizationaL-indicator{
        height: 172px;
        padding-top: 165px;
        .organizationaL-ind{
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background: #fff;
          margin-right: 10px;
        }
        .active-ind{
          width: 40px;
          height: 6px;
          background: #1566D4;
        }
      }
    }
    .organizationa-box-left-item:hover{
      .organizationaL-swiper-line{
        .organizationaL-swiper-icon{
          background: rgba($color: #000000, $alpha: 0.5);
          opacity: 1;
        }
      }
      .box-item-info {
        background: linear-gradient( 180deg, rgba(21,102,212,0) 0%, #1566D4 100%);
      }
      .box-item-title {
        background: linear-gradient( 360deg, rgba(21,102,212,0) 0%, #1566D4 100%);
      }
    }
    }

    &-right {
      .box-img-swpier{
          width: 341px;
          height: 192px;
          /deep/.el-carousel__container{
            width: 341px;
            min-height: 192px!important;
    }
        }
      .box-item {
        // -webkit-box-shadow: 3px 3px 8px #888888;
        // box-shadow: 3px 3px 8px #888888;
        box-shadow: 0px 0px 30px 0px rgba(10,49,128,0.1);
        .box-img {
          width: 343px;
          height: 192px;
          // background-image: url("../../assets/image/img1.png");
          background-size: cover;
          position: relative;
          .box-item-title {
            // background: linear-gradient( 360deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.5) 100%);
            position: absolute;
            top: 0;
            width: 100%;
          }
          .box-ind-line{
            position: absolute;
            bottom: 0;
            left: 0;
            width:100%;
            background: linear-gradient( 180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.8) 100%);
            .box-ind-area{
              .indItem{
                width: 6px;
height: 6px;
background: #FFFFFF;
border-radius: 3px;
margin-right: 10px;
              }
              .active-ind{
                width: 49px;
height: 6px;
background: #1566D4;
border-radius: 3px;
              }
            }
            .box-ind-line-icon{
               width: 50px;
               height: 50px;
               cursor: pointer;
               img{
                width: 12px;
                height: 21px;
               }
            }
          }
        }
        .box-img:hover{
              // .box-ind-line{
              //   background: linear-gradient( 180deg, rgba(21,102,212,0) 0%, #1566D4 100%)!important;
              // }
              .box-item-title{
                background: linear-gradient( 360deg, rgba(21,102,212,0) 0%, #1566D4 100%)!important;
              }
            }
        .orga-img {
          width: 343px;
          height: 192px;
          overflow: hidden;
          img {
            width: 343px;
            height: 192px;
            object-fit: cover
          }
        }
        .box-info {
          width: 363px;
          height: 192px;
          padding: 20px 15px;
          cursor: pointer;

          > div {
            font-family: "SourceHanSansCN-Regular";
            font-weight: 400;
            font-size: 20px;
          }

          > div:first-of-type {
            font-weight: bold;
            color: #333333;
            margin-bottom: 50px;
          }

          > div:last-of-type {
            color: rgba(51, 51, 51, 0.8);
          }
        }
      }
    }
  }
}

// 业务领域
.service-area {
  min-height: 600px;
  background-image: url("../../assets/image/bg1.png");
  background-size: cover;
  // max-width: 1440px;
  margin: 0 auto;
  // margin-top: 75px;
  padding-top: 75px;
  overflow: hidden;
.area-title-line{
  margin-bottom: 20px;
}
  .service-item {
    max-width: 1440px;
    margin: 0 auto;

    .service-item-title {
      font-family: "SourceHanSansCN-Regular";
      color: #ffffff;

      > span {
        font-weight: bold;
        font-size: 24px;
      }

      div {
        font-weight: 400;
        font-size: 16px;
        cursor: pointer;

        img {
          width: 50px;
          height: 14px;
          margin-left: 8px;
        }
      }
    }

    .service-item-scroll {
      margin: 20px 0;
      max-width: 1440px;
      overflow: hidden;

      .service-item-scroll-item {
        flex-shrink: 0;
        width: 336px;
        height: 189px;
        // background-image: url("../../assets/image/img1.png");
        background-size: cover;
        margin-right: 15px;
        position: relative;
        .item-img {
          width: 336px;
          height: 189px;
          overflow: hidden;
          img {
            width: 336px;
            object-fit: cover;
            height: 189px;
          }
        }
        > div:last-of-type {
          position: absolute;
          left: 0;
          width: 100%;
          bottom: 0px;
          padding: 14px 14px 14px 14px;
          font-family: "SourceHanSansCN-Regular";
          font-weight: bold;
          font-size: 16px;
          color: #ffffff;
          background: linear-gradient( 180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.8) 100%);
        }
      }
    }
  }
}

// h5
.sm-index {
  .area-title-line {
    padding: 0 25px;
    .area-title-left {
      > span:first-of-type {
        font-size: 48px;
        color: #ffffff;
      }
      > span:last-of-type {
        font-weight: 400;
        font-size: 20px;
        color: rgba(51, 51, 51, 0.5)!important;
        margin-left: 10px;
      }
    }
    .area-title-right {
      font-size: 24px;
    }
  }
  // 轮播图
  .swiper-area {
    min-height: 900px; 
    /deep/.el-carousel__container{
      min-height: 900px;
    }
    .swiper-box {
      position: relative;
      overflow: hidden;
      width: 100%;
      height: 900px;
      // .img-area {
      //   width: 100%;
      //   height: 900px;
        >img {
          object-fit: cover;
          width: 100%;
          height: 900px;
        }
      // }
      .banner-info {
        position: absolute;
        left: 56px;
        bottom: 400px;
        .banner-title {
          font-family: "SourceHanSansCN-Regular";
          font-weight: bold;
          font-size: 48px;
          color: #ffffff;
          line-height: 72px;
        }
        .banner-subTitle {
          font-family: "SourceHanSansCN-Regular";
          font-weight: 400;
          font-size: 22px;
          color: #ffffff;
          margin-top: 100px;
        }
      }
      .swiper-btn-line {
        position: absolute;
        bottom: 40px;
        width: 700px;
        left: 50%;
        margin-left: -350px;
        background-color: rgba(255, 255, 255, 0.2);
        box-shadow: 0px -20px 20px 0px rgba(10, 49, 128, 0.3);
        padding: 20px;
        > div:first-of-type,
        > div:last-of-type {
          width: 64px;
          flex-shrink: 0;
          img {
            width: 64px;
            height: 64px;
          }
        }
        .swiper-btn-middle {
          flex: 1;
          min-width: 0;
          padding: 0 20px 0 0px;
          > div {
            flex: 1;
            min-width: 0;
            flex-shrink: 0;
            height: 6px;
            background: #ffffff;
            border-radius: 3px;
            margin-left: 20px;
          }
          .swiper-active-item {
            background: #3b7af4;
          }
        }
      }
      /deep/.el-carousel__container {
        min-height: 900px;
      }
    }
  }
  // 新闻中心
  .news-area {
    background-image: url("../../assets/image/bg27.png");
    padding: 80px 24px;
    margin-top: 0;
    .area-title-line {
      padding: 0;
      .area-title-left {
        > span:first-of-type {
          color: #333333;
        }
        > span:last-of-type {
          color: #333333;
        }
      }
    }
    .news-type-line {
      width: 100%;
      margin-top: 30px;
      padding-bottom: 15px;
      border-bottom: 2px solid #3b7af4;
      .news-type-item {
        flex: 1;
        min-width: 0;
      }
      text-align: center;
      font-family: "SourceHanSansCN-Regular";
      font-weight: bold;
      font-size: 32px;
      // color: #1566d4;
      color: #333;
      line-height: 64px;
    }
    .news-type-active-item {
      background-color: #1566d4;
      color: #fff;
    }
    .swiper-box {
      width: 100%;
      margin: 0 auto;
      margin-top: 30px;
      // background: linear-gradient( 90deg, rgba(0,0,0,0.5) 0%, rgba(0,0,0,0) 100%);
      /deep/.el-carousel__container {
        min-height: 398px;
      }
      .img-area {
        width: 100%;
        position: relative;
        overflow: hidden;
        > img {
          width: 100%;
          height: 398px;
          object-fit: cover;
        }
        .left-icon {
          left: 20px;
          position: absolute;
          width: 64px;
          top: 50%;
          margin-top: -32px;
          img {
            width: 64px;
          }
        }
        .right-icon {
          right: 20px;
          position: absolute;
          width: 64px;
          top: 50%;
          margin-top: -32px;
          img {
            width: 64px;
          }
        }
        .img-info {
          padding: 20px 20px;
          position: absolute;
          bottom: 0;
          width: 100%;
          font-family: "SourceHanSansCN-Regular";
          font-size: 28px;
          color: #ffffff;
          background: linear-gradient( 180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.8) 100%);
        }
      }
    }
    .news-item {
      min-height: 156px;
      background: #ffffff;
      box-shadow: 0px 0px 20px 0px rgba(10, 49, 128, 0.2);
      margin-top: 20px;
      padding: 10px 20px;
      .news-item-left {
        font-family: "SourceHanSansCN-Regular";
        height: 136px;
        border-right: 2px solid rgba(51, 51, 51, 0.1);
        padding-right: 30px;
        > span:first-of-type {
          font-weight: bold;
          font-size: 36px;
          color: #666666;
          line-height: 54px;
        }
        > span:last-of-type {
          font-size: 22px;
          color: #666666;
          line-height: 33px;
          text-align: center;
        }
      }
      .news-item-right {
        font-family: "SourceHanSansCN-Regular";
        font-weight: bold;
        font-size: 28px;
        color: #333333;
        line-height: 42px;
        padding-left: 20px;
      }
    }
    .news-item:hover{
      border-bottom: 2px solid #1566D4;
      .news-item-left {
         span{
          color:       #1566D4;
         }
      }
      .news-item-right {
        color:       #1566D4;
      }
    }
    .active-news-item {
      border-bottom: 2px solid #1566d4;
      .news-item-left {
        > span:first-of-type {
          color: #1566d4;
        }
        > span:last-of-type {
          color: #1566d4;
        }
      }
      .news-item-right {
        color: #1566d4;
      }
    }
  }
  // 中心概况
  .centerIntr-area {
    background-image: url("../../assets/image/bg26.png");
    min-height: 895px;
    padding: 80px 24px;
    margin-top: 0;
    .area-title-line {
      .area-title-left {
        > span:last-of-type {
          color: rgba($color: #fff, $alpha: 0.5)!important;
        }
      }
    }
    .centerIntr-box {
      width: 100%;
      margin: 0 auto;
      .swiper-box {
        width: 100%;
        margin-top: 20px;
        .img-area {
          width: 100%;
          position: relative;
          height: 398px;
          > img {
            height: 398px;
          }
          .img-info {
            position: absolute;
            left: 0;
            bottom: 0px;
            width: 100%;
            background: linear-gradient( 180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.8) 100%);
            .img-info-top {
              width: 100%;
              height: 162px;
              > div:first-of-type,
              > div:last-of-type {
                width: 64px;
                flex-shrink: 0;
                // height: 64px;
                img {
                  width: 64px;
                  height: auto !important;
                  // height: 64px;
                }
              }
              .img-info-top-title {
                flex: 1;
                min-width: 0;
                font-weight: bold;
                font-size: 48px;
                color: #ffffff;
                font-family: "SourceHanSansCN-Regular";
              }
            }
          }
        }
      }
      .img-line {
        width: 100%;
        margin-top: 30px;
        display: flex;
        > div {
          height: 6px;
          flex: 1;
          flex-shrink: 0;
          background: rgba(255, 255, 255, 0.5);
        }
        .active-line {
          background: #1566d4;
        }
      }
      .centerIntr-content {
        padding-top: 20px;
        width: 100%;
        font-family: "SourceHanSansCN-Regular";
        font-size: 28px;
        color: #ffffff;
        line-height: 42px;
        text-align: left;
      }
      /deep/.el-carousel__container {
        min-height: 398px;
      }
    }
  }
  // 组织建设
  .organizationa-area {
    background-image: url("../../assets/image/bg25.png");
    min-height: 708px;
    padding: 80px 24px;
    margin-top: 0;
    .area-title-line {
      .area-title-left {
        > span:first-of-type {
          color: #333333;
        }
        > span:last-of-type {
          color: #333333;
        }
      }
    }
    .sm-organizationa-box {
      margin-top: 20px;
      .sm-organizationa-showBox {
        width: 100%;
        margin: 0 auto;
        background: #ffffff;
        box-shadow: 0px 0px 20px 0px rgba(10, 49, 128, 0.1);
        max-height: 480px;
        .sm-organizationa-box-left {
          flex-shrink: 0;
          width: 30%;
          overflow-y: auto;
          > div {
            line-height: 100px;
            text-align: center;
            font-family: "SourceHanSansCN-Regular";
            font-size: 32px;
            color: #333333;
            padding: 0 20px;
            box-shadow: none;
          }
          .active-organization {
            color: #1566d4;
            font-weight: bold;
            box-shadow: 0px 0px 20px 0px rgba(10,49,128,0.1)!important;
          }
        }
        .sm-organizationa-box-right {
          padding: 20px;
          flex: 1;
          min-width: 0;
          .sm-organizationa-box-img {
            width: 100%;
            min-height: 280px;
            text-align: center;
            img {
              width: 100%;
              object-fit: cover;
              height: 280px;
            }
          }
          .sm-organizationa-box-title {
            font-family: "SourceHanSansCN-Regular";
            font-size: 28px;
            color: #666666;
            margin-top: 8px;
            min-height: 84px;
          }
          .sm-organizationa-box-more {
            cursor: pointer;
            > span {
              font-family: "SourceHanSansCN-Regular";
              font-weight: 400;
              font-size: 24px;
              color: #3b7af4;
            }
            img {
              width: 50px;
              margin-left: 10px;
            }
          }
        }
      }
    }
  }
  //    业务领域
  .service-area {
    background-image: url("../../assets/image/bg24.png");
    padding:80px 24px;
    margin-top: 0;
    .area-title-line {
      .area-title-left {
        > span:last-of-type {
          color: rgba($color: #fff, $alpha: 0.5)!important;
        }
      }
    }
    .service-item-scroll {
      max-width: 100%!important;
    }
    .service-item {
      background: #fff;
      // margin-left: 25px;
      margin-top: 20px;
      padding: 30px 20px;
      max-width: 100%;
      .service-item-title {
        margin-bottom: 20px;
        > span {
          font-family: "SourceHanSansCN-Regular";
          font-weight: bold;
          font-size: 24px;
          color: #333333;
        }
      }
      .sm-service-item-scroll {
        // width: 100%;
        overflow: hidden;
        .service-item-scroll-item {
          background-image: none;
          margin-right: 20px;
          flex-shrink: 0;
          width: 300px;
          .service-item-img {
            width: 300px;
            height: 170px;
            overflow: hidden;
            padding: 0;
            img {
              width: 300px;
              height: 170px;
              object-fit: cover;
            }
          }
          .service-item-desc {
            font-family: "SourceHanSansCN-Regular";
            font-weight: bold;
            font-size: 24px;
            color: #333333;
            line-height: 36px;
            margin-top: 20px;
            margin: 0;
            padding: 0;
          }
        }
      }
      .sm-service-item-more {
        margin-top: 20px;
        font-size: 24px;
        color: #3b7af4;
        img {
          width: 50px;
          margin-left: 10px;
        }
      }
    }
  }
}

// -webkit-box-shadow: 3px 3px 10px #888888;
// box-shadow: 3px 3px 10px #888888;
// 移动端
@media (min-width: 576px)and (max-width:1200px){
   .area-title-line{
    padding: 0!important;
   }
   
}
</style>